import { columns } from './columns';
import { filters } from './filters';
import { query } from './query';

const appRoleConfig = {
    columns,
    filters,
    queryFilter: query,
};

export default appRoleConfig;
